/* eslint-disable max-len */

import { defineMessages } from 'react-intl'

export default defineMessages({
  title: 'Our customers and references',
  subTitle: 'More than 100 customers from all industries Tourism, healthcare, finance, automotive, construction and many more',
  allClientsBtn: 'Show all customers'
})
